module.exports = __webpack_public_path__ + "static/media/usmanCV_2.6c38e902.png";